import { render } from "./search.vue?vue&type=template&id=6e46680f&scoped=true&ts=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"

import "./search.vue?vue&type=style&index=0&id=6e46680f&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e46680f"]])

export default __exports__